import React from "react";
import { Icon, IconName } from "../../icon";

import "./sidebar-root-item.css";
import { MenuIds, useMenus } from "../../../hooks/useMenus";

export function SideBarRootItem({
	iconName,
	title,
	isActive,
	isDisabled,
	onClick,
}: {
	iconName: IconName;
	title: string;
	isActive: boolean;
	isDisabled?: boolean;
	onClick: () => void;
}) {
	const {
		actions: { setMenu },
	} = useMenus();

	// if a panel is both active and disabled, switch to root menu
	if (isActive && isDisabled) {
		setMenu(MenuIds.Root);
	}
	return (
		<div className={`sidebar-root-item ${isActive ? "sidebar-root-item--active" : ""}`}>
			<div className="sidebar-root-item__container">
				<button
					className="sidebar-root-item__button"
					disabled={isDisabled}
					onClick={onClick}
				>
					<Icon iconName={iconName} />
					<span className="sidebar-root-item__label">{title}</span>
				</button>
				{isActive && (
					<>
						<div className="sidebar-root-item__round-top">
							<div className="sidebar-root-item__round"></div>
						</div>
						<div className="sidebar-root-item__round-bottom">
							<div className="sidebar-root-item__round"></div>
						</div>
					</>
				)}
			</div>
		</div>
	);
}
